import { DEFAULT_TOP_SLOT_NAME } from "../../../helpers/takeoverConsts";

export function isDefaultTopSlot(event: googletag.events.SlotRenderEndedEvent) {
  return event.slot?.getSlotElementId?.() === DEFAULT_TOP_SLOT_NAME;
}
